import { snapshot } from 'valtio'
import { mainAtom } from '../main'

export const getMainSelection = (immutable: boolean = false) => {
  return immutable ? snapshot(mainAtom.selection) : mainAtom.selection
}
